import type { StediEligibilityStatus } from "@/src/models/stedi-eligibility-status";

const ELIGIBILITY_STATUS_LABEL: Record<StediEligibilityStatus, string> = {
  active: "Active",
  inactive: "Coverage inactive",
  unknown: "Unknown",
  failed: "Unknown",
};

export function getEligibilityPresentation({
  checkFailed,
  eligibilityStatus,
}: {
  checkFailed: boolean;
  eligibilityStatus: StediEligibilityStatus;
}) {
  if (checkFailed) {
    return {
      statusLabel: "Eligibility search failed",
      cardVariant: "destructive",
    } as const;
  }

  return {
    statusLabel: ELIGIBILITY_STATUS_LABEL[eligibilityStatus],
    cardVariant: eligibilityStatus === "active" ? "success" : eligibilityStatus === "inactive" ? "warn" : "outline",
  } as const;
}
